// src/pages/CreditorPaymentRecord/components/exportCreditorPaymentRecordCsv.js
import commaNumber from "comma-number";
import { formatToCompanyTimezone } from "../../../../lib/functions";

const format = commaNumber.bindWith(",", ".");
const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};
const fmtNum  = (val) => format(parseFloat(val || 0).toFixed(2));
const fmtDate = (v)   => (v ? formatToCompanyTimezone(v).split(" ")[0] : "-");

/**
 * @param {object} params
 * @param {Array}   params.list     - rows from Redux state.creditorPaymentRecord.list
 * @param {object}  params.filters  - for recordType check
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportCreditorPaymentRecordCsv = ({
  list,
  filters,
  title    = "Creditor/Supplier Payment Record",
  filename = "creditor_payment_record",
}) => {
  const isWithDetails = filters?.recordType === "with details";
  const rows = [[title], []];

  if (isWithDetails) {
    // ── With Details: detail rows + sub-total rows ────────────
    const headers = [
      "No.", "VCH No", "Date", "Creditor/Supplier",
      "Payment By", "Payment From", "Payment Amount",
    ].map(escape);

    rows.push(headers);

    let grandTotal = 0;
    let voucherNo  = 1;
    let rowInVoucher = 0;

    list.forEach((row) => {
      if (row.isSubtotal) {
        // sub-total row
        rows.push([
          "", "", "", "", "",
          "Sub Total:", fmtNum(row.subtotal),
        ].map(escape));
        rows.push(Array(7).fill("").map(escape)); // blank spacer
        voucherNo++;
        rowInVoucher = 0;
      } else {
        grandTotal += Number(row.pay_total || 0);
        rows.push([
          rowInVoucher === 0 ? voucherNo : "",
          rowInVoucher === 0 ? (row.pay_code || "") : "",
          rowInVoucher === 0 ? fmtDate(row.created_date) : "",
          rowInVoucher === 0 ? (row.acc_name  || "") : "",
          rowInVoucher === 0 ? (row.full_name || "") : "",
          row.from_acc_name || "",
          fmtNum(row.pay_total),
        ].map(escape));
        rowInVoucher++;
      }
    });

    rows.push([]); // spacer
    rows.push(["Grand Total:", "", "", "", "", "", fmtNum(grandTotal)].map(escape));

  } else {
    // ── Without Details: flat table ───────────────────────────
    const headers = [
      "No.", "VCH No", "Date", "Creditor/Supplier",
      "Payment By", "Total Amount",
    ].map(escape);

    rows.push(headers);

    let grandTotal = 0;

    list.forEach((row, i) => {
      grandTotal += Number(row.pay_total || 0);
      rows.push([
        i + 1,
        row.pay_code   || "",
        fmtDate(row.created_date),
        row.acc_name   || "",
        row.full_name  || "",
        fmtNum(row.pay_total),
      ].map(escape));
    });

    rows.push([]); // spacer
    rows.push(["Grand Total:", "", "", "", "", fmtNum(grandTotal)].map(escape));
  }

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};